// extracted by mini-css-extract-plugin
module.exports = {"main":"layout-module--main--1pEhS","fadeIn":"layout-module--fadeIn--1Msct"};